import {ComponentChild, FunctionalComponent, h} from "preact";

export const MessageFrame: FunctionalComponent<{
  time?: string;
  name?: string;
  clsName: string;
  children: ComponentChild;
}> = ({
       clsName,
       name,
       time,
       children
     }) => {
  
  const cn = "msgWrp" + (clsName ? (' ' + clsName) : '');
  
  return (
    <div className={cn}>
      <div className="chatMsg">
        {name && <p className="name">{name}</p>}
        {children}
        {time && <div className="time">{time}</div>}
      </div>
    </div>
  );
}
